import { format, parseISO } from "date-fns";

// Backend may emit naive ISO strings (no Z or offset) — anchor them to UTC
// so date-fns doesn't misread the wall-clock as already-local.
const TZ_MARKER = /[Zz]|[+-]\d{2}:?\d{2}$/;
const ensureUtc = (s: string): string => (TZ_MARKER.test(s) ? s : `${s}Z`);

const getShortTimezone = (date: Date): string => {
  const parts = new Intl.DateTimeFormat("en-US", { timeZoneName: "short" }).formatToParts(date);
  return parts.find((p) => p.type === "timeZoneName")?.value ?? "";
};

export const formatTimestamp = (dt: string | null | undefined): string => {
  if (!dt) {
    return "";
  }
  const date = parseISO(ensureUtc(dt));
  const tz = getShortTimezone(date);
  return `${format(date, "h:mm aa")} ${tz} | ${format(date, "MMM d, yyyy")}`;
};
